<app-toolbar>
  @if (canCreate$ | async) {
  <button mat-raised-button
          color="primary"
          matTooltip="New"
          class="toolbar-btn toolbar-btn--primary"
          (click)="onAddReport()">
    <mat-icon svgIcon="plus" />
    <span>New</span>
  </button>
  }

  <button
    mat-raised-button
    color="warn"
    class="toolbar-btn toolbar-btn--danger"
    (click)="resetAllFilters()">
    <mat-icon>filter_alt_off</mat-icon>
    <span>Reset all filters</span>
  </button>

  @if ((canCreate$ | async) && buttonScripts.cloneReport()) {
  <button mat-stroked-button
          id="CloneReport"
          matTooltip="Clone Report"
          class="toolbar-btn toolbar-btn--secondary"
          [disabled]="isDisabled()"
          (click)="cloneReport()">
    <mat-icon>content_copy</mat-icon>
    <span>Clone Report</span>
  </button>
}

  <button 
    mat-stroked-button 
    class="toolbar-btn" 
    [class.toolbar-btn--primary]="showDraftedOnly" 
    [class.toolbar-btn--secondary]="!showDraftedOnly" 
    (click)="draftedDeviationReports()"
  >
    <span>Drafted deviation reports</span>
  </button>

  <button 
    mat-stroked-button 
    class="toolbar-btn" 
    [class.toolbar-btn--primary]="!showDraftedOnly && !showWaitingForOnly" 
    [class.toolbar-btn--secondary]="showDraftedOnly || showWaitingForOnly" 
    (click)="deviationReports()"
  >
    <span>Deviation reports</span>
  </button>

  <button
    mat-stroked-button
    class="toolbar-btn"
    [class.toolbar-btn--primary]="showWaitingForOnly"
    [class.toolbar-btn--secondary]="!showWaitingForOnly"
    (click)="waitingForReports()"
  >
    <span>Waiting For</span>
  </button>

  <div class="table-header">
    @if (canCreate$ | async) {
    <!-- <app-dropdown [options]="reportOptions()" [activeValue]="statusFilter()" (changed)="filterRecord($event)" /> -->

    <div class="toolbar-search">
      <!-- <button class="btn-filter"
              mat-stroked-button
              matTooltip="Filter"
              class="toolbar-btn toolbar-btn--secondary">
        <mat-icon>filter_list</mat-icon>
        <span>Edit filters</span>
      </button> -->

      <mat-form-field appearance="outline" class="search-field">
        <input matInput placeholder="Search" [formControl]="control">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    }
  </div>
</app-toolbar>

<div class="report-container">

  <div class="table-container">
    <div class="table-scroll-wrapper">
      <table mat-table [dataSource]="paginatedData" matSort class="report-table" stickyHeader>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="masterToggle()" [checked]="isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" aria-label="Select all"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)" [checked]="selection.isSelected(row)" aria-label="Select row"></mat-checkbox>
          </td>
        </ng-container>

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th mat-header-cell mat-sort-header [disabled]="!isSortableColumn(column)" *matHeaderCellDef appColumnResize>
            <span>{{ getColumnLabel(column) }}</span>            
            <app-table-column-filter
              *ngIf="isServerFilterableColumn(column)"
              class="column-filter"
              [type]="getFilterType(column)"
              [options]="getFilterOptions(column)"
              [resetVersion]="filtersResetVersion"
              [class.active]="isActive(column)"
              (filterChange)="applyFilter($event, column)"
            />
          </th>
          <td mat-cell *matCellDef="let report">
            <div *ngIf="isLogoColumn(column); else normalCell" class="user-avatar" [title]="report[column]">
              {{ getInitials(report[column]) }}
            </div>
            <ng-template #normalCell>
              <ng-container *ngIf="column === 'reportType'">
                {{ getReportLabel(report[column]) }}
              </ng-container>
              <ng-container *ngIf="column === 'step'">
                {{ getStatusLabel(report['step']) }}
              </ng-container>
              <ng-container *ngIf="column === 'status'">
                <!-- {{ report['status'] | appApprovalStatusNaming }} -->
                {{ report['status'] }}
              </ng-container>
              <ng-container *ngIf="column === 'consequenceRanking'">
                {{ getConsequenceRankingLabel(report[column]) }}
              </ng-container>
              <ng-container *ngIf="column === 'facility'">
                {{ getFacilityLabel(report[column]) }}
              </ng-container>
              <ng-container *ngIf="column === 'reportTitleEn'">
                <a class="blue-link" [routerLink]="[report.id]" [queryParamsHandling]="'merge'">{{
                  report[column] }} </a>
              </ng-container>

              <ng-container *ngIf="isReferenceColumn(column)">
                <a *ngIf="report[column] && getReferenceHref(report, column)" class="blue-link" [href]="getReferenceHref(report, column)" target="_blank" rel="noopener noreferrer">
                  {{ report[column] }}
                </a>
                <span *ngIf="report[column] && !getReferenceHref(report, column)">{{ report[column] }}</span>
                <span *ngIf="!report[column]"></span>
              </ng-container>

              <ng-container
                *ngIf="column !== 'reportTitleEn'&& column !== 'facility'&& column !== 'step'&& column !== 'status'&& column !== 'reportType' && column !== 'consequenceRanking' && !isReferenceColumn(column)">
                <ng-container *ngIf="isDateColumn(column)">
                  {{ column =='createdOn' ? (report[column] | date : 'dd MMMM yyyy HH:mm') : report[column] | date :
                  'dd MMMM yyyy' }}
                </ng-container>

                <ng-container *ngIf="!isDateColumn(column)">
                  {{ report[column] }}
                </ng-container>
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="getCombinedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: getCombinedColumns()" (click)="selection.toggle(row)"
          [class.selected]="selection.isSelected(row)"></tr>
        <tr class="no-data" *matNoDataRow>
          <td class="text-center" [attr.colspan]="getCombinedColumns().length">
            No Record found
          </td>
        </tr>
      </table>
    </div>
    <div class="pagination-wrapper">
      <div class="custom-pagination">
        <!-- Page Size Selector -->
        <div class="page-size-selector">
          <span class="page-size-label">Items per page:</span>
          <select class="page-size-dropdown" [value]="pageSize" (change)="onPageSizeChange(+$any($event.target).value)">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>

        <!-- Page Info -->
        <div class="page-info">
          <span>{{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, getTotalCount()) }} of {{ getTotalCount() }}</span>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination-controls">
          <button
            class="pagination-btn"
            [disabled]="currentPage === 1 || getTotalCount() === 0"
            (click)="goToFirstPage()"
            title="First page">
            <mat-icon>first_page</mat-icon>
          </button>

          <button
            class="pagination-btn"
            [disabled]="currentPage === 1 || getTotalCount() === 0"
            (click)="goToPreviousPage()"
            title="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <!-- Page Numbers -->
          <div class="page-numbers">
            <ng-container *ngFor="let page of getPageNumbers()">
              <button
                *ngIf="page !== -1"
                class="page-number-btn"
                [class.active]="page === currentPage"
                (click)="onPageChange(page)">
                {{ page }}
              </button>
              <span *ngIf="page === -1" class="ellipsis">...</span>
            </ng-container>
          </div>

          <button
            class="pagination-btn"
            [disabled]="currentPage >= totalPages || getTotalCount() === 0"
            (click)="goToNextPage()"
            title="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>

          <button
            class="pagination-btn"
            [disabled]="currentPage >= totalPages || getTotalCount() === 0"
            (click)="goToLastPage()"
            title="Last page">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (isProcessing()) {
<div class="loading-overlay">
  <div class="loading-container">
    <mat-spinner diameter="60"></mat-spinner>
    <p class="loading-text">Processing...</p>
  </div>
</div>
}
